export const CONTROL = 'control';
